import permissions from '@hogwarts/permissions';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PreferenceConfig,
  PreferencesPanel,
} from '../../components/Settings/PreferencesPanel';
import { SettingsPanel } from '../../components/Settings/SettingsPanel';
import { OrganisationContext } from '../../context';
import {
  useFeature,
  useFederationFeature,
  useMutation,
  usePermission,
} from '../../hooks';
import { GET_ORGANISATION_DETAIL } from '../../queries';
import { TOGGLE_FEATURE } from '../../queries/features';

export const FederationUsersPreferences = () => {
  const { t } = useTranslation();
  const organisation = useContext(OrganisationContext);
  const fedFeatureControlPermission = usePermission(
    permissions.FEATURE_CONTROL,
    organisation.federation?.id
  );
  const fedEnabledEnforceMFA = useFederationFeature('security.enforcemfa');

  const [setOrgFeature] = useMutation(TOGGLE_FEATURE, {
    selector: 'toggleFeature',
    refetchQueries: [
      {
        query: GET_ORGANISATION_DETAIL,
        variables: {
          organisationKey: organisation.key,
        },
      },
    ],
  });

  const settings: PreferenceConfig[] = [
    {
      key: 'toggleEnforceMFA',
      label: t('Enforce MFA'),
      description: t(
        'Require users enable MFA for their accounts to access organisations in this federation.'
      ),
      value: fedEnabledEnforceMFA,
      disabled: !fedFeatureControlPermission,
      onUpdate: () => {
        setOrgFeature({
          variables: {
            ownerType: 'FEDERATION',
            ownerId: organisation.federation?.id,
            key: 'security.enforcemfa',
            enabled: !fedEnabledEnforceMFA,
          },
        });
      },
    },
  ];

  return (
    <SettingsPanel title={t('Preferences')}>
      <PreferencesPanel settings={settings} disabled={false} />
    </SettingsPanel>
  );
};
